export function getFirstNameFromPayerName(payer_name) {
  const first = payer_name.split(/[ ,]+/)[0];
  return first.charAt(0).toUpperCase() + first.slice(1);
}